import { useEffect, useState } from 'react';
import getToken from '../helpers/getToken';
import axios from 'axios';
import { JsonEditor } from "react-jsondata-editor";
import { useLocation, useNavigate } from "react-router-dom";
import { errorAlert, successAlert } from '../utils/toastifyAlerts'
import { ToastContainer } from 'react-toastify'
import putResume from '../helpers/putResume'
const backendUrl = process.env.REACT_APP_BACKEND_RESUME_URL;

const ResumeEditor = (state) => {
    // get id using the state from the edit button
    const location = useLocation();
    const navigate = useNavigate();
    const rid = location.state.resumeId;
    const resumeUrl = `${backendUrl}/${rid}`

    const [input, setInput] = useState('')
    const [newInput, setNewInput] = useState(null)

    //get token from localstorage
    const token = getToken();

    //get Resume using ID
    const getResume = async () => {
        await axios.get(resumeUrl, {
            headers: {
                // 'Content-Type': 'application/json',
                token: token,
            }
        }).then(response => {
            successAlert(response.data.msg)
            setInput(JSON.stringify(response.data.resume));
        })
    }

    // set resume data
    useEffect(() => {
        getResume()
        //eslint-disable-next-line
    }, [newInput])

    // let currentEditObj ;
    function saveJsonString(output) {
        if (output === undefined) {
            setNewInput('')
        } else {
            setNewInput(output)
        }
    }


    //parse json to generate axio body again
    let putBody = JSON.parse(newInput);

    const saveChanges = async () => {
        try{
            const resp = await putResume(rid, putBody, token)
            successAlert(resp.msg)
            setNewInput(JSON.stringify(resp.newresume));   
        }catch(e){
            errorAlert(e);
        }
    }

    const goBack = () => {
        navigate(-1);
    }

    return (
        <>
            <div className="title re">
                <h3 data-test='title'>resume editor</h3>
            </div>
            <div className='JSONEditorContainer'>
                <div className='JSONEditor'>
                    <JsonEditor jsonObject={input} onChange={(output) => saveJsonString(output)} />
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <button data-test='save' className="my-3 btnSCV btnSCV-a" onClick={saveChanges}>Save changes</button>
                        <button data-test='back' className="my-3 btnSCV btnSCV-a" onClick={goBack}>Back</button>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}

export default ResumeEditor